import { Message } from '../../../components';

import { connect } from 'react-redux';
import { RootState } from 'model/state';
import { MessageType } from 'model/Message';

const toComponentType = (type: MessageType): "success" | "danger" | "info" | undefined => {
  switch(type) {
    case MessageType.INFO:
      return 'info';
    case MessageType.SUCCESS:
      return 'success';
    case MessageType.ERROR:
      return 'danger';
  }
}

const mapStateToProps = (state: RootState) => ({
  message: state.message.message,
  description: state.message.description,
  type: toComponentType(state.message.type)
});

export default connect(mapStateToProps)(Message);
